<template>
  <v-snackbar bottom :value="updateExists" :timeout="0" color="primary">
    An update is available
    <v-btn text @click="refreshApp">Update</v-btn>
  </v-snackbar>
</template>

<script>
// https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
import update from '@/mixins/update'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  mixins: [update],
}
</script>
